import { styled } from '@mui/system'
import { Box, Typography } from '@mui/material'

export const FormLabel = styled('label')(`
  font-style: normal;
  font-weight: 600; // 500;
  font-size: 14px;
  line-height: 19px;
  color: #000;
  width:100%;
`)

export const FormError = styled(Box)(`
  font-size: 0.75rem;
  font-weight: 400;
  margin: 4px 14px 0 14px;
  color: #D14343;
`)

export const FormTypo = styled(Typography)(`
  font-size: 14px;
  line-height: 19px;
  color: #000;
`)
